/** @format */

import Cookies from 'js-cookie';

import {
    clearLocalStorageData,
    getLocalStorageData,
    setLocalStorageData,
} from './useLocalStorage';

import { saveOrUpdateRequest } from '../services/apiUtils';

const URL_TYPE: string = 'FROM_ENV';
const BASE_API_PATH = () => {
    if (URL_TYPE === 'LOCAL_HOST') return 'https://localhost:5000/api';
    if (URL_TYPE === 'FROM_ENV') return process.env.REACT_APP_API;
    // if (URL_TYPE === 'FROM_ENV') return 'https://digital-advisory-api.herokuapp.com/api';   ////For dev purpose
    // if (URL_TYPE === 'FROM_ENV')
    //     return 'https://digital-advisory-web-qa.herokuapp.com/api'; ////For 2nd dev purpose
    // return 'http://localhost:5000'; ////For 2nd dev purpose
    return '';
};

class Authorization {
    authUser: any;
    authUserKey: string;

    constructor() {
        this.authUser = null;
        this.authUserKey = 'userData';
    }

    //function
    async logOut(isReload?: boolean) {
        try {
            console.log('base path : ', BASE_API_PATH);
            const url = `${BASE_API_PATH()}/user/logout`;
            console.log('logout url : ', url);
            const response: any = await fetch(url, {
                method: 'POST',
                credentials: 'include',
            });
            const parsedResponse = await response.json();
            console.log('response in App', parsedResponse);
            if (parsedResponse.code == 200) {
                this.setAuthUser(null);
                isReload && window.location.reload();
            } else {
                console.log('error : Failed to logout user');
                throw new Error('Failed to logout user');
            }
        } catch (error) {
            console.log('error in logOut : ', error);
            throw new Error('Failed to logout user');
        }
    }

    /**
     * check is active user is logged in
     */
    isLoggedIn(): boolean {
        return !!this.authUser;

        //return true;
    }
    /**
     * set auth user details to class property
     */
    setAuthUser(data?: any) {
        this.authUser = data;
    }

    async doAuth() {
        try {
            const response: any = await saveOrUpdateRequest({
                url: 'user/details',
                method: 'POST',
                withCredentials: true,
            });
            console.log('response in App', response);
            if (response?.body?.data) {
                const parsed = response.body.data;
                console.log('parsed user details in Auth', parsed);
                const userObj = Array.isArray(parsed) ? parsed[0] : parsed;
                console.log('userObj in Auth', userObj);
                this.setAuthUser(userObj);
            } else {
                this.setAuthUser(null);
                console.log('error : Failed to fetch user details');
                throw new Error('Failed to fetch user details');
            }
        } catch (error) {
            this.setAuthUser(null);
            console.log('error in doAuth : ', error);
            throw new Error('Failed to fetch user details');
        }
    }
    /**
     * get logged in user details
     */
    getAuthUser() {
        if (this.isLoggedIn() && this.authUser) {
            return this.authUser;
        }
    }

    /**
     * login the user by setting it in local storage
     * @param {object} data
     */

    /**
     * check user is having the expected role
     *
     * @param role
     * @return boolean
     */
    isUserRole(role: string) {
        let user = this.getAuthUser();
        return user?.roleid && user.roleid === role;
    }
    /**
     * check logged user is admin
     *
     * @return boolean
     */
    isAdmin() {
        // return this.isUserRole(ADMIN_ROLE);
    }
    /**
     * check logged user is RSM Admin
     *
     * @return boolean
     */
    isRSMAdmin() {
        // return this.isUserRole(RSM_ROLE);
    }
    /**
     * check logged user DEV Admin
     *
     * @return boolean
     */
    isDEVAdmin() {
        // return this.isUserRole(DEVADMIN_ROLE);
    }

    /**
     * Get authentication access token
     *
     * @return string
     */
}

const authorizationCls = new Authorization();

export default authorizationCls;
